// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

const StyledList = styled<any, Theme>('ul')`
  list-style-type: none;
  outline: none;
  padding: 1.5rem 0;
  margin: 0;
  border-bottom: 1px solid ${props => props.theme.faq.subCategoryList.listBorderColor};
  &:empty {
    display: none;
  }
`;

export default StyledList;
